export enum ReviewsError {
    Default = 'default',
    Feedback = 'feedback',
}
